import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext from '../../contexts/language';
import AuthContext from '../../contexts/auth';

export default function Imprensa() {

    const { signed } = useContext(AuthContext);
    const { language } = useContext(LanguageContext);
    const lang = localStorage.getItem('language');

    return (
        <div className="page">
            <Header />
            <div className="content">
                <div className="full mt-60 mb-40">
                    <h3 className="title_b mb-30 text-center">
                        {language.menu_imprensa}
                    </h3>
                    <div className="row">
                        <div className="col-md-10 m-auto text text-center">
                            <div className="row">
                                <div className="col-md-12">
                                    <p>
                                        <strong>{lang==='pt' ? 'Relacionamento com a imprensa' : 'Press Relations' }</strong><br />
                                        2PRÓ Comunicação: +55 11 3030-9405<br />
                                        Belisa Barga: +55 13 99721-8682<br />
                                        <strong>alana@2pro.com.br</strong>
                                    </p>
                                    <div className="d-btn mt-30 mb-30">
                                        <Link to="/inscricao-imprensa" className="btn-send">{lang==='pt' ? 'CADASTRE-SE' : 'REGISTRATION' }</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
